/* BT Merch · redesign 2026-10 · v1.0
   Announcement slider, header mega menus, mobile "Shopping for" bar, vehicle finder,
   vehicle page year chips. Shares the saved vehicle with the older theme scripts
   (localStorage btm_garage_v1, events btm:garage and btm:open-finder). */
(function () {
  'use strict';
  if (window.__bmRedesign) return;
  window.__bmRedesign = true;

  var GK = 'btm_garage_v1';
  var R = window.BM_ROUTES || { root: '/', all: '/collections/all' };
  var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var finePointer = window.matchMedia ? window.matchMedia('(hover: hover) and (pointer: fine)') : { matches: false };
  var desktop = window.matchMedia ? window.matchMedia('(min-width: 990px)') : { matches: true };

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function own(o, k) { return Object.prototype.hasOwnProperty.call(o, k); }
  function plural(n, w) { return n + ' ' + w + (n === 1 ? '' : 's'); }
  function dash(s) { return String(s).replace(/((?:19|20)\d{2})\s*-\s*((?:19|20)\d{2})/g, '$1–$2'); }
  function trimSlash(u) { return String(u || '').replace(/\/+$/, ''); }
  function safePath(u) { return typeof u === 'string' && /^\/(?!\/)/.test(u) ? u : null; }
  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text !== undefined) e.textContent = text; return e; }

  /* ---------------- saved vehicle ("garage") ---------------- */
  function readGarage() {
    try {
      var g = JSON.parse(window.localStorage.getItem(GK));
      if (g && g.v === 1 && typeof g.slug === 'string' && /^[a-z0-9-]+$/.test(g.slug) && typeof g.year === 'number' &&
          g.year > 1989 && g.year < 2101 && typeof g.label === 'string' && g.label && g.label.length <= 80) return g;
    } catch (e) { /* blocked storage or bad value */ }
    return null;
  }
  function emitGarage(detail) {
    try { document.dispatchEvent(new CustomEvent('btm:garage', { detail: detail })); } catch (e) { /* very old browser */ }
  }
  function saveGarage(g) {
    try { window.localStorage.setItem(GK, JSON.stringify(g)); } catch (e) { /* private mode: nothing is remembered */ }
    emitGarage({ slug: g.slug, year: g.year, label: g.label });
  }
  function clearGarage() {
    try { window.localStorage.removeItem(GK); } catch (e) { /* ignore */ }
    emitGarage(null);
  }
  function garageUrl(g) {
    if (!g) return null;
    return safePath(g.url) || (trimSlash(R.all) + '/fit-' + g.slug + '-' + g.year + '?sort_by=best-selling');
  }
  function finderUrl(change) {
    return trimSlash(R.root) + '/' + (change ? '?vf=change' : '') + '#vehicle-finder';
  }

  /* ---------------- announcement slider ---------------- */
  function initAnn(root) {
    if (root.__bm) return;
    root.__bm = true;
    var slides = $$('.bm-ann__s', root);
    if (slides.length < 2) return;
    var i = 0, timer = null, paused = false;
    var speed = Math.max(3, parseInt(root.getAttribute('data-speed'), 10) || 5) * 1000;
    var auto = root.getAttribute('data-autoplay') !== 'false' && !reduceMotion;
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        var on = k === i;
        s.classList.toggle('is-on', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (on) s.removeAttribute('tabindex'); else s.setAttribute('tabindex', '-1');
      });
    }
    function stop() { if (timer) window.clearInterval(timer); timer = null; }
    function start() {
      stop();
      if (auto) timer = window.setInterval(function () { if (!paused && !document.hidden) show(i + 1); }, speed);
    }
    var prev = $('.bm-ann__nav--prev', root), next = $('.bm-ann__nav--next', root);
    if (prev) prev.addEventListener('click', function () { show(i - 1); start(); });
    if (next) next.addEventListener('click', function () { show(i + 1); start(); });
    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; });
    root.addEventListener('focusin', function () { paused = true; });
    root.addEventListener('focusout', function () { paused = false; });
    show(0);
    start();
  }

  /* ---------------- header mega menus ---------------- */
  var megas = [];
  function closeMegas(except) {
    megas.forEach(function (d) { if (d !== except && d.open) d.removeAttribute('open'); });
  }
  function pickMake(d, btn, focus) {
    var btns = $$('.bm-rail__btn', d);
    btns.forEach(function (b) {
      var on = b === btn;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
      b.tabIndex = on ? 0 : -1;
      var p = document.getElementById(b.getAttribute('aria-controls'));
      if (p) p.hidden = !on;
    });
    if (focus) btn.focus();
  }
  function selectGarageMake(d) {
    var g = readGarage();
    if (!g || d.__bmPicked) return;
    var label = g.label.replace(/^(19|20)\d{2}\s+/, '').toLowerCase();
    var hit = $$('.bm-rail__btn', d).filter(function (b) {
      var m = (b.getAttribute('data-make') || '').toLowerCase();
      return m && label.indexOf(m + ' ') === 0;
    })[0];
    if (hit) pickMake(d, hit, false);
  }
  function initMega(d) {
    if (d.__bm) return;
    d.__bm = true;
    megas.push(d);
    var sum = d.querySelector('summary');
    var tOpen = null, tClose = null, hoverAt = 0;
    d.addEventListener('mouseenter', function () {
      if (!finePointer.matches) return;
      window.clearTimeout(tClose);
      if (d.open) return;
      tOpen = window.setTimeout(function () { closeMegas(d); d.setAttribute('open', ''); hoverAt = Date.now(); }, 140);
    });
    d.addEventListener('mouseleave', function () {
      if (!finePointer.matches) return;
      window.clearTimeout(tOpen);
      tClose = window.setTimeout(function () { d.removeAttribute('open'); }, 260);
    });
    if (sum) {
      sum.addEventListener('click', function (e) {
        // the menu was just opened by the mouse: a click right after keeps it open instead of closing it
        if (d.open && Date.now() - hoverAt < 700) e.preventDefault();
      });
    }
    d.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && d.open) { d.removeAttribute('open'); if (sum) sum.focus(); }
    });
    d.addEventListener('toggle', function () {
      if (sum) sum.setAttribute('aria-expanded', d.open ? 'true' : 'false');
      if (d.open) { closeMegas(d); selectGarageMake(d); }
    });
    var btns = $$('.bm-rail__btn', d);
    btns.forEach(function (b, k) {
      var tHover = null;
      b.addEventListener('click', function () { d.__bmPicked = true; pickMake(d, b, false); });
      b.addEventListener('mouseenter', function () {
        if (!finePointer.matches) return;
        tHover = window.setTimeout(function () { d.__bmPicked = true; pickMake(d, b, false); }, 90);
      });
      b.addEventListener('mouseleave', function () { window.clearTimeout(tHover); });
      b.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowDown') n = btns[(k + 1) % btns.length];
        else if (e.key === 'ArrowUp') n = btns[(k - 1 + btns.length) % btns.length];
        else if (e.key === 'Home') n = btns[0];
        else if (e.key === 'End') n = btns[btns.length - 1];
        if (n) { e.preventDefault(); d.__bmPicked = true; pickMake(d, n, true); }
      });
    });
  }
  document.addEventListener('click', function (e) {
    megas.forEach(function (d) { if (d.open && !d.contains(e.target)) d.removeAttribute('open'); });
  });
  window.addEventListener('scroll', function () {
    if (!megas.some(function (d) { return d.open; })) return;
    if ($('.section-header.shopify-section-header-hidden')) closeMegas(null);
  }, { passive: true });

  // links that open the "Shop by Vehicle" menu (homepage "See every model")
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('[data-bm-open-mega]') : null;
    if (!a) return;
    var key = a.getAttribute('data-bm-open-mega');
    if (desktop.matches) {
      var d = $('[data-bm-mega="' + key + '"]');
      if (!d) return;
      e.preventDefault();
      e.stopPropagation();
      window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
      window.setTimeout(function () {
        closeMegas(d);
        d.setAttribute('open', '');
        var s = d.querySelector('summary');
        if (s) s.focus({ preventScroll: true });
      }, reduceMotion ? 0 : 260);
    } else {
      var drawerSum = $('header-drawer summary.header__icon--menu');
      var title = a.getAttribute('data-bm-branch') || '';
      if (!drawerSum) return;
      e.preventDefault();
      if (!drawerSum.parentNode.hasAttribute('open')) drawerSum.click();
      window.setTimeout(function () {
        var sub = $$('#menu-drawer .menu-drawer__menu > li > details > summary').filter(function (s) {
          return title && s.textContent.trim().indexOf(title) === 0;
        })[0];
        if (sub && !sub.parentNode.hasAttribute('open')) sub.click();
      }, 350);
    }
  });

  /* ---------------- mobile "Shopping for ..." bar ---------------- */
  function paintGbar() {
    $$('[data-bm-gbar]').forEach(function (bar) {
      var g = readGarage();
      bar.classList.toggle('is-on', !!g);
      if (!g) return;
      var t = $('.bm-gbar__t', bar), a = $('.bm-gbar__a', bar), chg = $('.bm-gbar__chg', bar);
      if (t) {
        t.textContent = '';
        t.appendChild(document.createTextNode('Shopping for '));
        var b = el('b', '', g.label);
        t.appendChild(b);
        t.appendChild(document.createTextNode(' '));
        t.appendChild(el('span', 'bm-gbar__ok', '✓'));
      }
      if (a) a.href = garageUrl(g);
      if (chg) chg.href = finderUrl(true);
    });
  }

  /* ---------------- vehicle data + finder ---------------- */
  var NAMES = {
    'toyota-rav4': ['Toyota', 'RAV4'], 'toyota-camry': ['Toyota', 'Camry'], 'hyundai-tucson': ['Hyundai', 'Tucson'],
    'tesla-model-y': ['Tesla', 'Model Y'], 'tesla-model-y-l': ['Tesla', 'Model Y L'], 'tesla-model-3': ['Tesla', 'Model 3'],
    'honda-cr-v': ['Honda', 'CR-V'], 'honda-civic': ['Honda', 'Civic'], 'jeep-wrangler-jl': ['Jeep', 'Wrangler JL'],
    'jeep-wrangler': ['Jeep', 'Wrangler'], 'ford-bronco': ['Ford', 'Bronco'], 'ford-bronco-sport': ['Ford', 'Bronco Sport'],
    'ford-f-150': ['Ford', 'F-150'], 'ford-f-150-lightning': ['Ford', 'F-150 Lightning'], 'ram-1500-classic': ['Ram', '1500 Classic']
  };
  var TAG_RX = /^fit-([a-z0-9]+(?:-[a-z0-9]+)*)-((?:19|20)\d{2})$/;
  function titleWord(w) { return /\d/.test(w) || w.length <= 3 ? w.toUpperCase() : w.charAt(0).toUpperCase() + w.slice(1); }
  function nameFor(slug) {
    if (NAMES[slug]) return NAMES[slug];
    var p = slug.split('-');
    var mk = titleWord(p[0]);
    return [mk, p.slice(1).map(titleWord).join(' ') || mk];
  }
  function hintFor(slug, year) {
    if (slug === 'tesla-model-y') return year >= 2026 ? '2026 is the refreshed New Model Y (often called Juniper). Earlier-design cars are 2020-2025.' : 'This is the earlier-design Model Y. If you have the refreshed New Model Y (often called Juniper), choose 2026.';
    if (slug === 'tesla-model-3') return year >= 2024 ? '2024 and newer is the refreshed Model 3 (often called Highland).' : 'This is the Model 3 before the 2024 refresh (Highland).';
    if (slug === 'jeep-wrangler-jl' && year === 2018) return 'Some 2018 Wranglers are the older JK. These results are for the JL.';
    return null;
  }
  // "2-Door 2021-2026" | "2009-2018 & Classic 2019-2024" | "All years" -> [{pre, a, b}] ([] = every year)
  function parseGen(gen) {
    var segs = [];
    String(gen || '').split('&').forEach(function (part) {
      var m = /^\s*(.*?)\s*((?:19|20)\d{2})\s*[-–]\s*((?:19|20)\d{2})\s*$/.exec(part);
      if (m) { segs.push({ pre: m[1], a: +m[2], b: +m[3] }); return; }
      m = /^\s*(.*?)\s*((?:19|20)\d{2})\s*\+?\s*$/.exec(part);
      if (m) segs.push({ pre: m[1], a: +m[2], b: +m[2] });
    });
    return segs;
  }
  function deriveFits(h) {
    var m = /^(.*?)-((?:19|20)\d{2})-((?:19|20)\d{2})$/.exec(h || '');
    if (m) return [[m[1], +m[2], +m[3]]];
    return h ? [[h, null, null]] : [];
  }

  var dataCache = null, dataWaiters = [];
  function readData(root) {
    var s = root.querySelector('script[data-bm-finder-data]');
    if (!s) return null;
    try { return JSON.parse(s.textContent); } catch (e) { return null; }
  }
  // per-product fit tags: inline on the page, or loaded once from /collections/all?view=bm-fits
  function withTags(data, cb) {
    if (data && typeof data.tags === 'string') { cb(data.tags, data.uniN); return; }
    if (dataCache) { cb(dataCache.tags, dataCache.uniN); return; }
    try {
      var c = JSON.parse(window.sessionStorage.getItem('bm_fits_v1'));
      if (c && typeof c.tags === 'string' && Date.now() - c.t < 30 * 60 * 1000) { dataCache = c; cb(c.tags, c.uniN); return; }
    } catch (e) { /* no cache */ }
    dataWaiters.push(cb);
    if (dataWaiters.length > 1) return;
    fetch(trimSlash(R.all) + '?view=bm-fits', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        dataCache = { tags: j && typeof j.tags === 'string' ? j.tags : '', uniN: j && j.uniN ? j.uniN : 0, t: Date.now() };
        try { window.sessionStorage.setItem('bm_fits_v1', JSON.stringify(dataCache)); } catch (e) { /* ignore */ }
      })
      .catch(function () { dataCache = { tags: '', uniN: 0, t: 0 }; })
      .then(function () { var w = dataWaiters; dataWaiters = []; w.forEach(function (f) { f(dataCache.tags, dataCache.uniN); }); });
  }
  function countTags(tagStr) {
    var cnt = {};
    String(tagStr || '').split('|').forEach(function (row) {
      if (!row) return;
      var seen = {};
      row.split(',').forEach(function (t) { if (t && !seen[t]) { seen[t] = 1; cnt[t] = (cnt[t] || 0) + 1; } });
    });
    return cnt;
  }

  /* Build the vehicle index from the menu data (makes -> lines) and the collection fit rules. */
  function buildIndex(data, tagCount) {
    var fits = data.fits || {};
    var skip = data.skip || [];
    var makes = [], byName = {}, coveredBy = {};
    (data.makes || []).forEach(function (mk) {
      var M = { name: mk.name, url: mk.url, n: mk.n || 0, lines: [] };
      (mk.lines || []).forEach(function (ln) {
        var parts = String(ln.t || '').split(' | ');
        var model = parts[0].trim(), gen = (parts[1] || '').trim();
        var f = own(fits, ln.h) ? fits[ln.h] : deriveFits(ln.h);
        if (skip.indexOf(ln.h) > -1) return;
        f.forEach(function (x) { coveredBy[x[0]] = coveredBy[x[0]] || []; coveredBy[x[0]].push(x); });
        if (!f.length && !ln.n) return;            // no fit tags and no products yet: nothing to show in the finder
        M.lines.push({ model: model, gen: gen, segs: parseGen(gen), fits: f, url: ln.u, n: ln.n || 0, h: ln.h });
      });
      makes.push(M);
      byName[M.name.toLowerCase()] = M;
    });
    // vehicles that have fit- tags but no line in the menu (for example fit-ford-bronco-2023): add them
    var orphan = {};
    Object.keys(tagCount).forEach(function (t) {
      var m = TAG_RX.exec(t);
      if (!m) return;
      var slug = m[1], y = +m[2];
      var cov = (coveredBy[slug] || []).some(function (x) { return x[1] === null || (y >= x[1] && y <= x[2]); });
      if (cov) return;
      (orphan[slug] = orphan[slug] || []).push(y);
    });
    Object.keys(orphan).forEach(function (slug) {
      var ys = orphan[slug].sort(function (a, b) { return a - b; });
      var nm = nameFor(slug);
      var M = byName[nm[0].toLowerCase()];
      if (!M) { M = { name: nm[0], url: null, n: 0, lines: [] }; makes.push(M); byName[nm[0].toLowerCase()] = M; }
      var line = { model: nm[1], gen: '', segs: [{ pre: '', a: ys[0], b: ys[ys.length - 1] }], fits: [[slug, ys[0], ys[ys.length - 1]]], url: null, n: 0, h: null, orphan: true };
      // keep it next to its relatives: after "Model Y" for "Model Y L", before "Bronco Sport" for "Bronco"
      var at = -1, k;
      for (k = 0; k < M.lines.length; k++) if (line.model.indexOf(M.lines[k].model + ' ') === 0) at = k + 1;
      if (at < 0) for (k = 0; k < M.lines.length; k++) if (M.lines[k].model.indexOf(line.model + ' ') === 0) { at = k; break; }
      if (at < 0) M.lines.push(line); else M.lines.splice(at, 0, line);
    });
    makes.forEach(function (M) {
      M.lines.forEach(function (L) { L.key = L.h || ('tag:' + L.fits[0][0]); });
    });
    // the year list follows the store data (menu years and fit- tags), never the calendar
    var maxY = 0, minY = 2005;
    makes.forEach(function (M) { M.lines.forEach(function (L) { L.segs.forEach(function (s) { if (s.b > maxY) maxY = s.b; if (s.a < minY) minY = s.a; }); }); });
    if (!maxY) maxY = new Date().getFullYear();
    var years = [];
    for (var y = maxY; y >= Math.max(minY, 1990); y--) years.push(y);
    return { makes: makes, years: years };
  }
  function segFor(L, y) {
    if (!L.segs.length) return { pre: '', a: null, b: null };
    for (var i = 0; i < L.segs.length; i++) if (y >= L.segs[i].a && y <= L.segs[i].b) return L.segs[i];
    return null;
  }
  function lineLabel(L, y) {
    var s = segFor(L, y);
    if (!s) return L.model;
    var out = L.model + (s.pre ? ' ' + s.pre : '');
    if (s.a !== null && !L.orphan) out += ' ' + (s.a === s.b ? String(s.a) : s.a + '–' + s.b);
    return out;
  }
  function vehicleName(M, L, y) {
    var s = segFor(L, y);
    return M.name + ' ' + L.model + (s && s.pre ? ' ' + s.pre : '');
  }
  function tagsFor(L, y) {
    var out = [];
    L.fits.forEach(function (f) { if (f[1] === null || (y >= f[1] && y <= f[2])) out.push({ slug: f[0], tag: 'fit-' + f[0] + '-' + y }); });
    return out;
  }
  // what the finder says for one vehicle
  function verdict(idx, M, L, y, tagCount, uni) {
    var name = y + ' ' + vehicleName(M, L, y);
    var best = null;
    tagsFor(L, y).forEach(function (t) {
      var n = tagCount[t.tag] || 0;
      if (!best || n > best.n) best = { slug: t.slug, tag: t.tag, n: n };
    });
    var slug = best ? best.slug : (L.fits[0] ? L.fits[0][0] : (L.h || 'vehicle').replace(/-(?:19|20)\d{2}-(?:19|20)\d{2}$/, ''));
    var base = { name: name, slug: slug, year: y };
    if (best && best.n > 0) {
      base.kind = 'ok';
      base.url = trimSlash(R.all) + '/' + best.tag + '?sort_by=best-selling';
      base.go = 'Shop ' + plural(best.n, 'product');
      base.title = plural(best.n, 'product') + ' listed for your ' + name;
      base.hint = hintFor(best.slug, y) || 'We’ll remember your vehicle on this device.';
      return base;
    }
    if (L.n > 0 && L.url) {
      base.kind = 'coll';
      base.url = L.url;
      base.go = 'Shop all ' + L.model + ' (' + L.n + ')';
      base.title = 'Nothing is listed for the ' + name + ' by year yet';
      base.hint = 'Our ' + L.model + ' collection has ' + plural(L.n, 'item') + '. Some are listed for other years, so check the years on each listing.';
      return base;
    }
    base.kind = 'soon';
    base.url = uni.url;
    base.go = uni.n ? 'Shop universal gear (' + uni.n + ')' : 'Shop universal gear';
    base.title = 'New ' + vehicleName(M, L, y) + ' gear is coming soon';
    base.hint = 'Nothing is listed for the ' + name + ' yet. Universal-fit items work in any vehicle.';
    return base;
  }

  var CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="9"/><path d="m8 12.5 2.6 2.5L16 9.5"/></svg>';
  var CLOCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>';

  function Finder(root) {
    var self = this;
    this.root = root;
    this.data = readData(root) || {};
    this.fixedMake = root.getAttribute('data-make') || '';
    this.sel = { year: $('[data-f="year"]', root), make: $('[data-f="make"]', root), model: $('[data-f="model"]', root) };
    this.go = $('[data-f="go"]', root);
    this.res = $('[data-f="res"]', root);
    this.reset = $('[data-f="reset"]', root);
    this.uni = { url: this.data.uni || (trimSlash(R.all) + '/universal-fit'), n: this.data.uniN || 0 };
    this.tagCount = {};
    this.idx = buildIndex(this.data, {});
    this.state = { year: null, make: null, key: null };
    this.fillYears();
    this.bind();
    this.restore();
    withTags(this.data, function (tags, uniN) {
      self.tagCount = countTags(tags);
      if (uniN) self.uni.n = uniN;
      self.idx = buildIndex(self.data, self.tagCount);
      self.restore();
    });
    // "Change vehicle" links elsewhere open /?vf=change#vehicle-finder
    var params = null;
    try { params = new URLSearchParams(window.location.search); } catch (e) { params = null; }
    if (params && params.get('vf') === 'change' && !this.fixedMake) {
      params.delete('vf');
      var qs = params.toString();
      try { window.history.replaceState(null, '', window.location.pathname + (qs ? '?' + qs : '') + window.location.hash); } catch (e) { /* ignore */ }
      clearGarage();
      this.state = { year: null, make: null, key: null };
      this.render();
      window.setTimeout(function () { self.focus(); }, 80);
    }
    if (!this.fixedMake) document.addEventListener('btm:open-finder', function () { self.focus(); });
  }
  Finder.prototype.fillYears = function () {
    var s = this.sel.year;
    if (!s) return;
    var keep = s.value;
    s.textContent = '';
    s.appendChild(new Option('Select', ''));
    this.idx.years.forEach(function (y) { s.appendChild(new Option(String(y), String(y))); });
    if (keep) s.value = keep;
  };
  Finder.prototype.makeObj = function (name) {
    var n = String(name || '').toLowerCase();
    return this.idx.makes.filter(function (M) { return M.name.toLowerCase() === n; })[0] || null;
  };
  Finder.prototype.fixedName = function () {
    if (!this.fixedMake) return null;
    var M = this.makeObj(this.fixedMake);
    return M ? M.name : this.fixedMake;
  };
  Finder.prototype.linesFor = function (M, y) {
    if (!M || !y) return [];
    return M.lines.filter(function (L) { return !!segFor(L, y); });
  };
  Finder.prototype.current = function () {
    var s = this.state, M = this.makeObj(s.make);
    var list = this.linesFor(M, s.year);
    var L = null;
    for (var i = 0; i < list.length; i++) if (list[i].key === s.key) L = list[i];
    return { M: M, list: list, L: L };
  };
  Finder.prototype.bind = function () {
    var self = this;
    if (this.sel.year) this.sel.year.addEventListener('change', function () {
      self.state.year = parseInt(self.sel.year.value, 10) || null;
      self.render();
      self.afterPick('year');
    });
    if (this.sel.make) this.sel.make.addEventListener('change', function () {
      self.state.make = self.sel.make.value || null;
      self.state.key = null;
      self.render();
      self.afterPick('make');
    });
    if (this.sel.model) this.sel.model.addEventListener('change', function () {
      self.state.key = self.sel.model.value || null;
      self.render();
      self.afterPick('model');
    });
    if (this.go) this.go.addEventListener('click', function (e) {
      if (self.go.getAttribute('aria-disabled') === 'true') {
        e.preventDefault();
        var s = self.state;
        var next = !s.year ? self.sel.year : (!s.make && self.sel.make ? self.sel.make : self.sel.model);
        if (next && !next.disabled) next.focus();
      }
    });
    if (this.reset) this.reset.addEventListener('click', function () {
      clearGarage();
      self.state = { year: null, make: self.fixedName(), key: null };
      self.render();
      if (self.sel.year) self.sel.year.focus();
    });
  };
  Finder.prototype.afterPick = function (step) {
    var c = this.current();
    if (this.state.year && c.M && c.L) { this.save(); return; }
    // move to the next empty step
    if (step === 'year' && !c.M && this.sel.make && !this.fixedMake) this.sel.make.focus();
    else if ((step === 'year' || step === 'make') && c.M && !c.L && this.sel.model && !this.sel.model.disabled) this.sel.model.focus();
  };
  Finder.prototype.restore = function () {
    if (this.fixedMake) this.state.make = this.fixedName();
    if (this.state.key && this.current().L) { this.render(); return; }
    var g = readGarage();
    if (g) {
      var self = this, found = null;
      this.idx.makes.forEach(function (M) {
        if (found || (self.fixedMake && M.name.toLowerCase() !== self.fixedMake.toLowerCase())) return;
        self.linesFor(M, g.year).forEach(function (L) {
          if (found) return;
          if (tagsFor(L, g.year).some(function (t) { return t.slug === g.slug; })) found = { M: M, L: L };
        });
      });
      if (found) this.state = { year: g.year, make: found.M.name, key: found.L.key };
      else if (!this.state.year && this.idx.years.indexOf(g.year) > -1) this.state.year = g.year;
    }
    this.render();
  };
  Finder.prototype.render = function () {
    var s = this.state;
    if (this.idx.years.indexOf(s.year) < 0) s.year = null;
    if (this.sel.year) {
      if (this.sel.year.options.length !== this.idx.years.length + 1) this.fillYears();
      this.sel.year.value = s.year ? String(s.year) : '';
      this.sel.year.closest('.bm-fsel').classList.toggle('is-set', !!s.year);
    }
    if (this.sel.make && !this.fixedMake) {
      var ms = this.sel.make;
      ms.textContent = '';
      ms.appendChild(new Option('Select', ''));
      this.idx.makes.forEach(function (M) { ms.appendChild(new Option(M.name, M.name)); });
      if (!this.makeObj(s.make)) s.make = null;
      ms.value = s.make || '';
      ms.disabled = !s.year;
      ms.closest('.bm-fsel').classList.toggle('is-set', !!s.make);
    }
    var c = this.current();
    if (!c.L && c.list.length === 1 && s.year && c.M) { s.key = c.list[0].key; c = this.current(); }
    if (!c.L) s.key = null;
    var mo = this.sel.model;
    if (mo) {
      mo.textContent = '';
      if (s.year && c.M && !c.list.length) {
        mo.appendChild(new Option('No models listed for ' + s.year, ''));
      } else {
        mo.appendChild(new Option('Select', ''));
        var bmShort = c.list.map(function (L) { var sg = segFor(L, s.year); return L.model + (sg && sg.pre ? ' ' + sg.pre : ''); }); c.list.forEach(function (L, i) { var dup = bmShort.indexOf(bmShort[i]) !== bmShort.lastIndexOf(bmShort[i]); mo.appendChild(new Option(dup ? lineLabel(L, s.year) : bmShort[i], L.key)); });
      }
      mo.value = c.L ? c.L.key : '';
      mo.disabled = !(s.year && c.M && c.list.length);
      mo.closest('.bm-fsel').classList.toggle('is-set', !!c.L);
    }
    var v = null;
    if (s.year && c.M && c.L) v = verdict(this.idx, c.M, c.L, s.year, this.tagCount, this.uni);
    else if (s.year && c.M && !c.list.length) {
      v = { kind: 'soon', url: this.uni.url, go: this.uni.n ? 'Shop universal gear (' + this.uni.n + ')' : 'Shop universal gear',
        title: 'Nothing is listed for the ' + s.year + ' ' + c.M.name + ' yet', hint: 'Universal-fit items work in any vehicle.' };
    }
    this.v = v;
    if (this.go) {
      if (v) {
        this.go.href = v.url;
        this.go.textContent = v.go;
        this.go.removeAttribute('aria-disabled');
      } else {
        this.go.href = '#';
        this.go.textContent = !s.year ? (this.fixedMake ? 'Choose year and model' : 'Choose year, make and model') : (!c.M ? 'Choose make and model' : 'Choose your model');
        this.go.setAttribute('aria-disabled', 'true');
      }
    }
    if (this.res) {
      if (v) {
        this.res.hidden = false;
        this.res.className = 'bm-fres ' + (v.kind === 'ok' ? 'is-ok' : 'is-soon');
        this.res.innerHTML = (v.kind === 'ok' ? CHECK : CLOCK) + '<div><b></b><span class="bm-fres__hint"></span></div>';
        this.res.querySelector('b').textContent = v.title;
        this.res.querySelector('.bm-fres__hint').textContent = v.hint || '';
      } else {
        this.res.hidden = true;
        this.res.textContent = '';
      }
    }
    if (this.reset) this.reset.hidden = !readGarage();
  };
  Finder.prototype.save = function () {
    var s = this.state, v = this.v, c = this.current();
    if (!v || !v.slug || !c.L) return;
    saveGarage({ v: 1, slug: v.slug, year: s.year, label: (s.year + ' ' + vehicleName(c.M, c.L, s.year)).slice(0, 80), ts: Date.now(), url: v.url });
    if (this.reset) this.reset.hidden = false;
  };
  Finder.prototype.focus = function () {
    if (this.root.scrollIntoView) this.root.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
    var s = this.state, c = this.current();
    var t = !s.year ? this.sel.year : (!c.M && this.sel.make ? this.sel.make : (!c.L ? this.sel.model : this.go));
    if (t) window.setTimeout(function () { t.focus({ preventScroll: true }); }, reduceMotion ? 0 : 350);
  };
  function initFinder(root) {
    if (root.__bm) return;
    root.__bm = new Finder(root);
  }

  /* ---------------- vehicle page: year chips + "your vehicle" note ---------------- */
  function initYearChips(box) {
    if (box.__bm) return;
    box.__bm = true;
    var data = readData(box.closest('[data-bm-vpage]') || box.parentNode) || {};
    var h = box.getAttribute('data-handle');
    var fits = data.fits && own(data.fits, h) ? data.fits[h] : deriveFits(h);
    if (!fits.length) return;
    withTags(data, function (tags) {
      var cnt = countTags(tags);
      if (box.hasAttribute('data-auto')) {
        // "all years" collection: one chip per model year that has products
        var ys = {};
        Object.keys(cnt).forEach(function (t) {
          var m = TAG_RX.exec(t);
          if (m && fits.some(function (f) { return f[0] === m[1] && (f[1] === null || (+m[2] >= f[1] && +m[2] <= f[2])); })) ys[m[2]] = 1;
        });
        var list = Object.keys(ys).sort();
        if (!list.length) { var w = box.closest('.bm-ywrap'); if (w) w.hidden = true; return; }
        list.forEach(function (y) {
          var a = el('a', 'bm-yc', y);
          a.setAttribute('data-year', y);
          a.appendChild(el('small', '', ''));
          box.appendChild(a);
        });
      }
      $$('[data-year]', box).forEach(function (a) {
        var y = +a.getAttribute('data-year');
        var best = null;
        fits.forEach(function (f) {
          if (f[1] !== null && (y < f[1] || y > f[2])) return;
          var t = 'fit-' + f[0] + '-' + y, n = cnt[t] || 0;
          if (!best || n > best.n) best = { t: t, n: n };
        });
        var small = a.querySelector('small');
        if (!best) { if (small) small.textContent = '0'; return; }
        if (small) small.textContent = String(best.n);
        a.href = trimSlash(box.getAttribute('data-coll')) + '/' + best.t;
        if (window.location.pathname.replace(/\/+$/, '').slice(-best.t.length - 1) === '/' + best.t) a.classList.add('is-on');
      });
    });
  }
  function initGnote(box) {
    if (box.__bm) return;
    box.__bm = true;
    function paint() {
      var g = readGarage(), make = (box.getAttribute('data-make') || '').toLowerCase();
      var label = g ? g.label.replace(/^(19|20)\d{2}\s+/, '').toLowerCase() : '';
      var other = !!(g && make && label.indexOf(make + ' ') !== 0);
      box.hidden = !other;
      if (!other) return;
      var t = $('.bm-gnote__t', box), a = $('.bm-gnote__a', box);
      if (t) {
        t.textContent = '';
        t.appendChild(document.createTextNode('Shopping for a '));
        t.appendChild(el('b', '', g.label));
        t.appendChild(document.createTextNode('? These ' + box.getAttribute('data-make') + ' parts aren’t listed for it.'));
      }
      if (a) { a.href = garageUrl(g); a.textContent = 'Shop parts for your ' + g.label.replace(/^(19|20)\d{2}\s+/, '') + ' →'; }
    }
    paint();
    document.addEventListener('btm:garage', paint);
  }

  /* ---------------- policy pages: title band, "On this page" list, numbered sections, help card ----------------
     Only the layout changes; the policy text stays exactly as written in Shopify Admin > Settings > Policies. */
  var POLICY_NAMES = {
    'privacy-policy': 'Privacy Policy', 'refund-policy': 'Refund Policy', 'shipping-policy': 'Shipping Policy',
    'terms-of-service': 'Terms of Service', 'contact-information': 'Contact Information', 'legal-notice': 'Legal Notice',
    'subscription-policy': 'Subscription Policy'
  };
  var SMALL_WORDS = /^(a|an|and|as|at|by|for|from|in|into|of|on|or|per|the|to|via|vs|with)$/;
  var NUM_HEAD = /^(\d{1,2})\.\s+(\S.{1,90})$/;
  var SEC_HEAD = /^section\s+(\d{1,2})\s*[-–—:.]\s*(\S.{1,90})$/i;
  var ICON_SHIELD = '<svg class="bm-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M12 3 5 6v5c0 4.5 3 8 7 10 4-2 7-5.5 7-10V6l-7-3z"/><path d="m9 12 2 2 4-4"/></svg>';
  var ICON_PRINT = '<svg class="bm-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M7 9V3.5h10V9"/><rect x="3.5" y="9" width="17" height="8" rx="2"/><path d="M7 14h10v6.5H7z"/></svg>';
  function titleCase(s) {
    return String(s).toLowerCase().replace(/[a-z0-9][a-z0-9'’]*/g, function (w, at) {
      return at > 0 && SMALL_WORDS.test(w) ? w : w.charAt(0).toUpperCase() + w.slice(1);
    });
  }
  function txt(n) { return String(n.textContent || '').replace(/ /g, ' ').replace(/\s+/g, ' ').trim(); }
  function blankNode(n) {
    if (n.nodeType === 3) return txt(n) === '';
    if (n.nodeType !== 1) return true;
    if (n.tagName === 'BR') return true;
    if (/^(IMG|VIDEO|IFRAME|TABLE|HR)$/.test(n.tagName) || n.querySelector('img,video,iframe,table')) return false;
    return txt(n) === '';
  }
  function headInfo(t) {
    var m = t.match(SEC_HEAD);
    if (m) return { num: m[1], title: titleCase(m[2]) };
    m = t.match(NUM_HEAD);
    if (m) return { num: m[1], title: m[2].replace(/[.:]\s*$/, '') };
    if (/^[A-Z][A-Z0-9 &,;'’\/-]{3,60}$/.test(t)) return { num: '', title: titleCase(t) };
    return null;
  }
  // bold text at the start of a paragraph or right after a line break, written like a heading ("1. Carriers", "SECTION 2 - ...")
  function lineStartStrongs(p) {
    var out = [], atStart = true;
    Array.prototype.forEach.call(p.childNodes, function (n) {
      if (n.nodeType === 1 && n.tagName === 'BR') { atStart = true; return; }
      if (blankNode(n)) return;
      if (atStart && n.nodeType === 1 && /^(STRONG|B)$/.test(n.tagName)) {
        var info = headInfo(txt(n));
        if (info) { info.node = n; out.push(info); }
      }
      atStart = false;
    });
    return out;
  }
  function splitAt(p, marks) {
    var res = { pre: [], parts: [] }, cur = null, k = 0;
    Array.prototype.slice.call(p.childNodes).forEach(function (n) {
      if (k < marks.length && n === marks[k].node) { cur = { info: marks[k], nodes: [] }; res.parts.push(cur); k++; return; }
      (cur ? cur.nodes : res.pre).push(n);
    });
    return res;
  }
  function capsCheck(p) {
    var letters = txt(p).replace(/[^A-Za-z]/g, ''), up = letters.replace(/[^A-Z]/g, '').length;
    if (letters.length > 120 && up / letters.length > 0.7) p.classList.add('bm-pol__caps');
  }
  // lines separated by <br> become paragraphs; short lines in a row (an address) stay together
  function toParas(nodes) {
    var lines = [], line = [], out = [], p = null, prevShort = false;
    nodes.forEach(function (n) {
      if (n.nodeType === 1 && n.tagName === 'BR') { lines.push(line); line = []; } else line.push(n);
    });
    lines.push(line);
    lines.forEach(function (l) {
      if (!l.some(function (n) { return !blankNode(n); })) return;
      var t = l.map(txt).join(' ').replace(/\s+/g, ' ').trim(), short = t.length <= 70 && !/[.!?]$/.test(t);
      if (p && short && prevShort) p.appendChild(document.createElement('br'));
      else { p = el('p'); out.push(p); }
      l.forEach(function (n) { p.appendChild(n); });
      prevShort = short;
    });
    out.forEach(capsCheck);
    return out;
  }
  function polSlug(s, used) {
    var b = String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 48) || 'section', id = b, k = 2;
    while (used[id] || document.getElementById(id)) id = b + '-' + k++;
    used[id] = true;
    return id;
  }
  function policyLinks() {
    var seen = {}, out = [];
    $$('.bm-ftr a[href*="/policies/"]').forEach(function (a) {
      var p = a.pathname.replace(/\/+$/, '');
      if (seen[p]) return;
      seen[p] = true;
      out.push({ href: a.getAttribute('href'), path: p, label: txt(a) });
    });
    return out;
  }
  function polSpy(toc, secs) {
    var links = $$('a', toc), els = secs.map(function (s) { return document.getElementById(s.id); }), busy = false;
    function update() {
      busy = false;
      var hh = parseInt(window.getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 72, k = 0;
      for (var i = 0; i < els.length; i++) { if (els[i] && els[i].getBoundingClientRect().top <= hh + 40) k = i; else break; }
      var last = els[els.length - 1];
      if (k > 0 && last && last.getBoundingClientRect().bottom <= window.innerHeight - 24) k = els.length - 1;
      links.forEach(function (a, i) {
        a.classList.toggle('is-on', i === k);
        if (i === k) a.setAttribute('aria-current', 'location'); else a.removeAttribute('aria-current');
      });
      var a = links[k];
      if (a && toc.scrollHeight > toc.clientHeight + 4) {
        var top = a.offsetTop, bottom = top + a.offsetHeight;
        if (top < toc.scrollTop || bottom > toc.scrollTop + toc.clientHeight) toc.scrollTop = top - toc.clientHeight / 3;
      }
    }
    window.addEventListener('scroll', function () { if (!busy) { busy = true; window.requestAnimationFrame(update); } }, { passive: true });
    update();
  }
  function initPolicy(box) {
    if (box.__bmPol) return;
    box.__bmPol = true;
    try { buildPolicy(box); } catch (err) {
      box.style.opacity = '1';
      box.style.animation = 'none';
      if (window.console) window.console.warn('BT Merch: policy layout skipped', err);
    }
  }
  function buildPolicy(box) {
    var body = $('.shopify-policy__body', box), rte = body && ($('.rte', body) || body);
    if (!rte) { box.style.opacity = '1'; box.style.animation = 'none'; return; }
    var src = rte;
    while (src.children.length === 1 && src.firstElementChild.tagName === 'DIV' && txt(src) === txt(src.firstElementChild)) src = src.firstElementChild;
    var words = txt(src).split(' ').length;
    var hTag = $(':scope > h2', src) ? 'H2' : ($(':scope > h3', src) ? 'H3' : '');
    var intro = [], secs = [], cur = null, updated = '';
    function put(n) { (cur ? cur.body : intro).push(n); }
    function open(info) { cur = { num: info.num || '', title: info.title, body: [] }; secs.push(cur); }
    Array.prototype.slice.call(src.childNodes).forEach(function (n) {
      if (blankNode(n)) return;
      if (n.nodeType !== 1) { var p0 = el('p'); p0.appendChild(n); put(p0); return; }
      var t = txt(n);
      if (!updated && t.length < 90 && /^(last updated|last revised|effective date)\s*:/i.test(t)) { updated = t.replace(/^[^:]*:\s*/, ''); return; }
      if (hTag && n.tagName === hTag) {
        var m = t.match(NUM_HEAD);
        open(m ? { num: m[1], title: m[2] } : { num: '', title: t });
        return;
      }
      if (n.tagName === 'P') {
        var marks = lineStartStrongs(n);
        if (marks.length) {
          var parts = splitAt(n, marks);
          toParas(parts.pre).forEach(put);
          parts.parts.forEach(function (pt) { open(pt.info); toParas(pt.nodes).forEach(put); });
          return;
        }
        if (n.querySelector('br') && t.length > 400) { toParas(Array.prototype.slice.call(n.childNodes)).forEach(put); return; }
        capsCheck(n);
      }
      put(n);
    });

    var key = location.pathname.replace(/\/+$/, '').split('/').pop();
    var h1 = $('.shopify-policy__title h1', box) || $('h1', box);
    var name = POLICY_NAMES[key] || (h1 ? titleCase(txt(h1)) : '');
    var here = location.pathname.replace(/\/+$/, '');

    // title band
    var hero = el('header', 'bm-pol__hero'), hin = el('div', 'bm-wrap');
    hero.appendChild(hin);
    var cr = el('nav', 'bm-crumbs bm-pol__crumbs'), ol = el('ol'), li = el('li'), home = el('a', '', 'Home'), cs = el('span', '', name);
    cr.setAttribute('aria-label', 'Breadcrumb');
    home.href = (window.BM_ROUTES && window.BM_ROUTES.root) || '/';
    li.appendChild(home); ol.appendChild(li);
    li = el('li'); cs.setAttribute('aria-current', 'page'); li.appendChild(cs); ol.appendChild(li);
    cr.appendChild(ol); hin.appendChild(cr);
    var eb = el('span', 'bm-pol__eyebrow');
    eb.innerHTML = ICON_SHIELD;
    eb.appendChild(document.createTextNode('Store policies'));
    hin.appendChild(eb);
    var h = h1 || el('h1');
    h.className = 'bm-pol__title';
    h.textContent = name;
    hin.appendChild(h);
    var meta = [];
    if (updated) meta.push('Last updated ' + updated);
    if (secs.length > 1) meta.push(plural(secs.length, 'section'));
    meta.push(Math.max(1, Math.round(words / 230)) + ' min read');
    hin.appendChild(el('p', 'bm-pol__meta', meta.join(' · ')));
    var bar = el('div', 'bm-pol__bar'), links = policyLinks();
    if (links.length > 1) {
      var tabs = el('nav', 'bm-pol__tabs');
      tabs.setAttribute('aria-label', 'Store policies');
      links.forEach(function (l) {
        var ta = el('a', '', l.label);
        ta.href = l.href;
        if (l.path === here) { ta.className = 'is-on'; ta.setAttribute('aria-current', 'page'); }
        tabs.appendChild(ta);
      });
      bar.appendChild(tabs);
    }
    var pr = el('button', 'bm-pol__print');
    pr.type = 'button';
    pr.innerHTML = ICON_PRINT;
    pr.appendChild(document.createTextNode('Print or save as PDF'));
    pr.addEventListener('click', function () { window.print(); });
    bar.appendChild(pr);
    hin.appendChild(bar);

    // reading frame: intro, numbered sections, "On this page" list
    var lay = el('div', 'bm-wrap bm-pol__layout' + (secs.length > 1 ? ' has-toc' : '')), doc = el('article', 'bm-pol__doc'), used = {}, ib = null;
    if (intro.length) {
      ib = el('div', 'bm-pol__intro');
      intro.forEach(function (n) { ib.appendChild(n); });
      var f = ib.firstElementChild;
      if (f && f.tagName === 'P' && f.firstElementChild && /^(STRONG|B)$/.test(f.firstElementChild.tagName) && txt(f).indexOf(txt(f.firstElementChild)) === 0) f.classList.add('bm-pol__key');
      doc.appendChild(ib);
    }
    secs.forEach(function (s) {
      var sec = el('section', 'bm-pol__sec'), hh = el('h2', 'bm-pol__h');
      s.id = polSlug(s.title, used);
      sec.id = s.id;
      if (s.num) {
        var nb = el('span', 'bm-pol__n');
        nb.appendChild(el('span', 'bm-visually-hidden', 'Section '));
        nb.appendChild(document.createTextNode(s.num));
        hh.appendChild(nb);
      }
      hh.appendChild(el('span', '', s.title));
      sec.appendChild(hh);
      s.body.forEach(function (n) { sec.appendChild(n); });
      doc.appendChild(sec);
    });
    if (secs.length > 1) {
      var list = el('ol', 'bm-pol__toc-list');
      secs.forEach(function (s) {
        var tli = el('li'), ta = el('a');
        ta.href = '#' + s.id;
        if (s.num) ta.appendChild(el('span', 'bm-pol__tn', s.num));
        ta.appendChild(el('span', '', s.title));
        tli.appendChild(ta);
        list.appendChild(tli);
      });
      var toc = el('nav', 'bm-pol__toc');
      toc.setAttribute('aria-label', 'On this page');
      toc.appendChild(el('p', 'bm-pol__toc-h', 'On this page'));
      toc.appendChild(list);
      var mt = el('details', 'bm-pol__mtoc');
      mt.appendChild(el('summary', '', 'On this page (' + secs.length + ')'));
      mt.appendChild(list.cloneNode(true));
      mt.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('a')) mt.removeAttribute('open'); });
      doc.insertBefore(mt, ib ? ib.nextSibling : doc.firstChild);
      lay.appendChild(toc);
    }
    lay.appendChild(doc);

    // help card (contact details come from the footer)
    var hw = el('div', 'bm-wrap'), help = el('div', 'bm-pol__help'), ht = el('div'), line = el('span');
    var mail = $('.bm-ftr .bm-biz a[href^="mailto:"]'), tel = $('.bm-ftr .bm-biz a[href^="tel:"]');
    ht.appendChild(el('b', '', 'Questions about this policy?'));
    line.appendChild(document.createTextNode('Email us or use the contact form, and include your order number if you have one.'));
    if (tel) {
      var ta2 = el('a', '', txt(tel));
      ta2.href = tel.getAttribute('href');
      line.appendChild(document.createTextNode(' Phone: '));
      line.appendChild(ta2);
    }
    ht.appendChild(line);
    help.appendChild(ht);
    var hb = el('div', 'bm-pol__help-btns');
    if (mail) {
      var b1 = el('a', 'bm-btn bm-btn--white', 'Email ' + txt(mail));
      b1.href = mail.getAttribute('href');
      hb.appendChild(b1);
    }
    var b2 = el('a', 'bm-btn bm-btn--ghost', 'Contact form');
    b2.href = '/pages/contact-us';
    hb.appendChild(b2);
    help.appendChild(hb);
    hw.appendChild(help);

    var oldTitle = $('.shopify-policy__title', box);
    box.insertBefore(hero, box.firstChild);
    box.insertBefore(lay, hero.nextSibling);
    box.insertBefore(hw, lay.nextSibling);
    if (oldTitle && oldTitle.parentNode) oldTitle.parentNode.removeChild(oldTitle);
    if (body && body.parentNode) body.parentNode.removeChild(body);
    box.classList.add('bm-pol');
    if (secs.length > 1) polSpy($('.bm-pol__toc', box), secs);
    if (location.hash.length > 1) {
      var target = document.getElementById(decodeURIComponent(location.hash.slice(1)));
      if (target) target.scrollIntoView();
    }
  }

  /* ---------------- product details photos ---------------- */
  function fitImg(img) {
    if (img.__bmFit) return;
    img.__bmFit = true;
    function check() {
      var w = img.naturalWidth, h = img.naturalHeight;
      if (w && h) img.classList.toggle('bm-fitv', h <= w * 1.25);
    }
    if (img.complete) check();
    img.addEventListener('load', check);
  }

  /* ---------------- start (and restart when the theme editor reloads a section) ---------------- */
  function scan(root) {
    $$('[data-bm-ann]', root).forEach(initAnn);
    $$('[data-bm-mega]', root).forEach(initMega);
    $$('[data-bm-finder]', root).forEach(initFinder);
    $$('[data-bm-ychips]', root).forEach(initYearChips);
    $$('[data-bm-gnote]', root).forEach(initGnote);
    $$('.shopify-policy__container', root).forEach(initPolicy);
    $$('.bm-pd__body img', root).forEach(fitImg);
    paintGbar();
  }
  function start() { scan(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  document.addEventListener('btm:garage', paintGbar);
  window.addEventListener('storage', function (e) { if (!e.key || e.key === GK) paintGbar(); });
})();
